import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Ky Tracy Creative - Professional Photography & Creative Services',
  description = 'Professional portrait photography, writing, and social media services by Ky Tracy. Specializing in empowering and authentic portraits that capture your unique essence.',
  keywords = 'portrait photography, professional photography, family portraits, individual portraits, creative writing, social media management, Ky Tracy, Ky Tracy Creative',
  image = '/logo.png',
  url = window.location.href,
  type = 'website',
  author = 'Ky Tracy',
}) => {
  const siteUrl = process.env.REACT_APP_SITE_URL || 'https://kytracycreative.com';
  const fullUrl = url.startsWith('http') ? url : `${siteUrl}${url}`;
  const fullImage = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Ky Tracy Creative" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      <meta name="twitter:creator" content="@kytracycreative" />

      {/* Additional SEO */}
      <link rel="canonical" href={fullUrl} />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    </Helmet>
  );
};

export default SEO;
